import { SignJWT } from 'jose';
import { getGlobal } from '../../global';
import { selectUser } from '../../global/selectors/users';

export interface JWTPayload {
  userId: string;
  username?: string;
  firstName?: string;
  lastName?: string;
  iat?: number;
  exp?: number;
}

export async function generateJWT(): Promise<string | null> {
  try {
    const global = getGlobal();
    const currentUserId = global.currentUserId;
    
    if (!currentUserId) {
      return null;
    }

    const user = selectUser(global, currentUserId);
    if (!user) {
      return null;
    }

    const jwtSecret = process.env.JWT_SECRET;
    if (!jwtSecret) {
      console.warn('JWT_SECRET is not set in environment variables');
      return null;
    }

    const secret = new TextEncoder().encode(jwtSecret);
    
    const username = user.usernames?.find((u: any) => u.isActive)?.username 
      || user.usernames?.[0]?.username 
      || undefined;

    const payload: JWTPayload = {
      userId: currentUserId,
      username,
      firstName: user.firstName,
      lastName: user.lastName,
    };

    const jwt = await new SignJWT(payload)
      .setProtectedHeader({ alg: 'HS256' })
      .setIssuedAt()
      .setExpirationTime('1h')
      .sign(secret);

    return jwt;
  } catch (error) {
    console.error('Error generating JWT token:', error);
    return null;
  }
}

